import { DashboardTarget } from '@akin-home/dashboards';

const dimensions: Record<DashboardTarget, { height: number; width: number }> = {
  [DashboardTarget.mobile_landscape]: {
    height: 360,
    width: 640,
  },
  [DashboardTarget.mobile_portrait]: {
    height: 640,
    width: 360,
  },
  [DashboardTarget.tablet_landscape]: {
    height: 768,
    width: 1366,
  },
  [DashboardTarget.tablet_portrait]: {
    height: 1024,
    width: 768,
  },
};

export const getBuilderDimensionsFromTargets = (
  targets?: DashboardTarget[]
) => {
  if (!targets || targets.includes(DashboardTarget.tablet_landscape))
    return dimensions.tablet_landscape;

  if (targets.includes(DashboardTarget.tablet_portrait)) {
    return dimensions.tablet_portrait;
  }

  if (targets.includes(DashboardTarget.mobile_landscape)) {
    return dimensions.mobile_landscape;
  }

  if (targets.includes(DashboardTarget.mobile_portrait)) {
    return dimensions.mobile_portrait;
  }

  return dimensions.tablet_landscape;
};
